import React, { useEffect, useState } from 'react';

const GoogleOAuthCallbackBridge = () => {
    const [error, setError] = useState('');

    useEffect(() => {
        try {
            const apiBase = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/$/, '');
            const forwardUrl = `${apiBase}/auth/complete/google-oauth${window.location.search || ''}`;
            window.location.replace(forwardUrl);
        } catch (err) {
            console.error('Error redirigiendo callback de Google:', err);
            setError('No se pudo reenviar el callback al backend');
        }
    }, []);

    return (
        <div className="min-h-screen bg-[#0b1020] text-white flex items-center justify-center p-6">
            <div className="w-full max-w-md rounded-2xl border border-white/15 bg-white/10 backdrop-blur-xl p-6 text-center">
                {error ? (
                    <>
                        <h1 className="text-xl font-semibold text-red-300">Callback invalido</h1>
                        <p className="mt-3 text-white/85">{error}</p>
                    </>
                ) : (
                    <>
                        <h1 className="text-xl font-semibold">Procesando Google Sign-In</h1>
                        <p className="mt-3 text-white/85">Redirigiendo al backend...</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default GoogleOAuthCallbackBridge;
